import React, { useState } from 'react';

import InputRange from 'react-input-range';

import { formatUSDCurrency } from '../helpers/format';

const InputRangeSlider = ({ min, max, confirmValue, setConfirmValue }) => {
  return (
    <div className="input-range-container">
      <InputRange
        step={1000}
        formatLabel={(value) => null}
        draggableTrack={false}
        maxValue={max}
        minValue={min}
        value={confirmValue}
        onChange={setConfirmValue}
        onChangeComplete={(args) => console.log(args)}
      />
      <div className="input-range__labels">
        <div>{formatUSDCurrency(min, 0)}</div>
        <div>{formatUSDCurrency(max, 0)}</div>
      </div>
    </div>
  );
};

export default InputRangeSlider;
